import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class ArcEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITARC;
}